import { useEffect } from 'react';
import { useModelContext } from '@getdutchie/agent-react';
import { useQueryClient } from '@tanstack/react-query';
import { createTool, type ToolConfig } from './utils/create-tool';
import { brandsTool } from './get-brand-catalog';
import { inventoryTool } from './get-inventory';
import { reorderRecommendationsTool } from './get-reorder-recommendations';
import { salesSummaryTool } from './get-sales-summary';
import { listPurchaseOrdersTool } from './list-purchase-orders';
import { draftPurchaseOrderTool } from './draft-purchase-order';
import { submitPurchaseOrderTool } from './submit-purchase-order';

const toolConfigs: ToolConfig[] = [
  brandsTool,
  inventoryTool,
  reorderRecommendationsTool,
  salesSummaryTool,
  listPurchaseOrdersTool,
  draftPurchaseOrderTool,
  submitPurchaseOrderTool,
];

export function useRegisterTools() {
  const { registerTool, unregisterTool } = useModelContext();
  const queryClient = useQueryClient();

  useEffect(() => {
    toolConfigs.forEach((config) => registerTool(createTool(config, queryClient)));
    return () => toolConfigs.forEach((config) => unregisterTool(config.name));
  }, [queryClient, registerTool, unregisterTool]);
}
